// @flow

import * as React from 'react';
import Box from 'sail/Box';
import {motion} from 'framer-motion';
import {
  useContentAnimation,
  variants,
  transition,
} from 'docs/shell/content/ContentAnimationProvider';

import './Page.scss';

type PageProps = {|
  children: React.Node,
  prefs: {[pref: string]: string},
  title?: string,
  badge?: {[key: string]: any},
|};

export const Page = ({children, title}: PageProps) => {
  const {direction} = useContentAnimation();
  return (
    <Box
      role="tabpanel"
      className="Page"
      padding={{vertical: 12}}
      style={{overflow: 'hidden'}}
      id={title ? `content-${title}` : undefined}
      aria-labelledby={title ? `tab-${title}` : undefined}
    >
      <motion.div
        key="Page"
        initial="enter"
        animate="center"
        exit="exit"
        custom={direction}
        variants={variants}
        transition={transition}
      >
        {children}
      </motion.div>
    </Box>
  );
};
